import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { IHospitalLicense } from 'app/models/licenses/hospital/hospital-license';

@Component({
  selector: 'app-hospital-contacts-export',
  templateUrl: './hospital-contacts-export.component.html',
  styleUrl: './hospital-contacts-export.component.scss'
})
export class HospitalContactsExportComponent {
  @ViewChild('pdf') pdf!: PDFExportComponent;

  public today: Date = new Date(Date.now());

    constructor(@Inject(MAT_DIALOG_DATA) public license: IHospitalLicense,
              private dialogRef: MatDialogRef<HospitalContactsExportComponent>) { }

  exportPDF(): void {
    const fileName = this.license.hospitalDBAName + ' ' + 'Contacts.pdf';
    this.pdf.saveAs(fileName);
  }

  close(): void {
    this.dialogRef.close();
  }
}
